export default __webpack_public_path__ + "static/media/sana-about.87cdf929.mp4";